import { memo } from 'react'
import { withFormikField } from '../../../hoc/withFormikField'
import Input from '../../Input/Input'

export default memo(withFormikField('input')(Input))
